<!-- commenting -->
@if (settings === menuSettings.StoreSetting) {
  <nav class="side-nav" role="navigation" aria-label="Main navigation">
    <div class="logo">
      <img
        class="cursor-pointer"
        routerLink="/home"
        routerLinkActive="active-link"
        height="27"
        width="24"
        alt=""
        ngSrc="/assets/logo.svg"
        priority />
    </div>
    <div class="side-nav-top">
      <ul class="sideMenu">
        <li class="menu-list">
          <a
            class="menu-link"
            routerLink="home"
            aria-label="Home"
            routerLinkActive="active-link"
            ariaCurrentWhenActive="page"
            [appShortcutTooltip]="getShortcutInfo('HOME')">
            <app-ce-icon
              [name]="'home'"
              [svg_class]="['cursor-pointer', 'main-menu']"></app-ce-icon>
          </a>
        </li>
      </ul>
      <div class="border-line"></div>
      <ul class="sideMenu">
        <li class="menu-list">
          <a
            class="menu-link"
            routerLinkActive="active-link"
            ariaCurrentWhenActive="page"
            tabindex="0"
            aria-haspopup="true"
            [attr.aria-expanded]="isSubmenuOpen"
            (focus)="onParentFocus($event)"
            (blur)="onParentBlur($event)"
            (keydown)="onParentMenuKeydown($event)">
            <app-ce-icon
              [name]="'person'"
              [svg_class]="['cursor-pointer', 'main-menu']"></app-ce-icon>
            <ul
              class="hover-menu custom-dropdown border-radius side-nav-list h3-bold primary-100"
              role="menu"
              aria-label="Customer submenu">
              <li>
                @let customersInfo = getShortcutInfo('CUSTOMERS');
                <a
                  class="cursor-pointer"
                  routerLink="customers"
                  role="menuitem"
                  tabindex="-1"
                  (keydown)="onSubmenuKeydown($event)"
                  [appShortcutTooltip]="getShortcutInfo('CUSTOMERS')"
                  [appShortcutTooltipKeysOnly]="true"
                  (click)="onSubmenuClick($event)"
                  ><span>
                    <img alt="" height="17" width="16" alt="" ngSrc="/assets/person.svg"
                  /></span>
                  <div class="menu-text">{{ customersInfo.name }}</div>
                </a>
              </li>
              <li>
                @let visitorsInfo = getShortcutInfo('VISITORS');
                <a
                  class="cursor-pointer"
                  routerLink="visitors"
                  role="menuitem"
                  tabindex="-1"
                  (keydown)="onSubmenuKeydown($event)"
                  [appShortcutTooltip]="getShortcutInfo('VISITORS')"
                  [appShortcutTooltipKeysOnly]="true"
                  (click)="onSubmenuClick($event)"
                  ><span>
                    <img alt="" height="17" width="16" alt="" ngSrc="/assets/review.svg"
                  /></span>
                  <div class="menu-text">{{ visitorsInfo.name }}</div>
                </a>
              </li>
              <li>
                @let customerAttributesInfo = getShortcutInfo('ATTRIBUTES');
                <a
                  class="cursor-pointer"
                  routerLink="customers/attributes"
                  role="menuitem"
                  tabindex="-1"
                  (keydown)="onSubmenuKeydown($event)"
                  [appShortcutTooltip]="getShortcutInfo('ATTRIBUTES')"
                  [appShortcutTooltipKeysOnly]="true"
                  (click)="onSubmenuClick($event)"
                  ><span
                    ><app-ce-icon [name]="'tasks'" [svg_class]="['primary-50']"></app-ce-icon
                  ></span>
                  <div class="menu-text">{{ customerAttributesInfo.name }}</div>
                </a>
              </li>
            </ul>
          </a>
        </li>
        <li class="menu-list">
          <a
            class="menu-link"
            routerLinkActive="active-link"
            ariaCurrentWhenActive="page"
            tabindex="0"
            aria-haspopup="true"
            [attr.aria-expanded]="isSubmenuOpen"
            (focus)="onParentFocus($event)"
            (blur)="onParentBlur($event)"
            (keydown)="onParentMenuKeydown($event)">
            <app-ce-icon
              [name]="'product'"
              [svg_class]="['cursor-pointer', 'main-menu']"></app-ce-icon>
            <ul
              class="hover-menu custom-dropdown border-radius side-nav-list h3-bold primary-100"
              role="menu"
              aria-label="Product submenu">
              <li>
                @let productsInfo = getShortcutInfo('PRODUCTS');
                <a
                  class="cursor-pointer"
                  routerLink="products"
                  role="menuitem"
                  tabindex="-1"
                  (keydown)="onSubmenuKeydown($event)"
                  [appShortcutTooltip]="getShortcutInfo('PRODUCTS')"
                  [appShortcutTooltipKeysOnly]="true"
                  (click)="onSubmenuClick($event)"
                  ><span
                    ><app-ce-icon [name]="'box'" [svg_class]="['primary-50']"></app-ce-icon
                  ></span>
                  <div class="menu-text">{{ productsInfo.name }}</div>
                </a>
              </li>
              <li>
                @let categoryInfo = getShortcutInfo('CATEGORY');
                <a
                  class="cursor-pointer"
                  routerLink="products/categories"
                  role="menuitem"
                  tabindex="-1"
                  (keydown)="onSubmenuKeydown($event)"
                  [appShortcutTooltip]="getShortcutInfo('CATEGORY')"
                  [appShortcutTooltipKeysOnly]="true"
                  (click)="onSubmenuClick($event)"
                  ><span
                    ><app-ce-icon [name]="'list'" [svg_class]="['primary-50']"></app-ce-icon
                  ></span>
                  <div class="menu-text">{{ categoryInfo.name }}</div>
                </a>
              </li>
              <li>
                @let productAttributeInfo = getShortcutInfo('ATTRIBUTE');
                <a
                  class="cursor-pointer"
                  routerLink="products/attributes"
                  role="menuitem"
                  tabindex="-1"
                  (keydown)="onSubmenuKeydown($event)"
                  [appShortcutTooltip]="getShortcutInfo('ATTRIBUTE')"
                  [appShortcutTooltipKeysOnly]="true"
                  (click)="onSubmenuClick($event)"
                  ><span
                    ><app-ce-icon [name]="'tasks'" [svg_class]="['primary-50']"></app-ce-icon
                  ></span>
                  <div class="menu-text">{{ productAttributeInfo.name }}</div>
                </a>
              </li>
              <li>
                @let inventoryInfo = getShortcutInfo('INVENTORY');
                <a
                  class="cursor-pointer"
                  routerLink="products/inventory"
                  role="menuitem"
                  tabindex="-1"
                  (keydown)="onSubmenuKeydown($event)"
                  [appShortcutTooltip]="getShortcutInfo('INVENTORY')"
                  [appShortcutTooltipKeysOnly]="true"
                  (click)="onSubmenuClick($event)"
                  ><span
                    ><app-ce-icon [name]="'inventory'" [svg_class]="['primary-50']"></app-ce-icon
                  ></span>
                  <div class="menu-text">{{ inventoryInfo.name }}</div>
                </a>
              </li>
            </ul>
          </a>
        </li>
        <!-- TODO:
                <li class="menu-list">
                  <a
                    class="menu-link"
                    ariaCurrentWhenActive="page"
                    [ngClass]="{
                      'active-link': isActive(active_link, ['orders', 'replacements', 'refunds'])
                    }">
                    <app-ce-icon [name]="'cart'" [svg_class]="['cursor-pointer', 'main-menu']"></app-ce-icon>
                    <ul class="hover-menu custom-dropdown border-radius side-nav-list h3-bold primary-100">
                      <li>
                        <a class="cursor-pointer" routerLink="/orders"
                          ><span
                            ><app-ce-icon
                              [name]="'cart'"
                              [svg_class]="['cursor-pointer', 'primary-50']"></app-ce-icon></span
                          >Orders</a
                        >
                      </li>
                      <li>
                        <a class="cursor-pointer" routerLink="/refunds"
                          ><span
                            ><app-ce-icon
                              [name]="'refund_icon'"
                              [svg_class]="['cursor-pointer', 'primary-50']"></app-ce-icon></span
                          >Refunds</a
                        >
                      </li>
                      <li>
                        <a class="cursor-pointer" routerLink="/replacements"
                          ><span
                            ><app-ce-icon
                              [name]="'refund_icon'"
                              [svg_class]="['cursor-pointer', 'primary-50']"></app-ce-icon></span
                          >Replacements</a
                        >
                      </li>
                    </ul>
                     <div class="tool d-none">
                    <app-tooltip label="Orders" Type="default" size="medium" data-bs-placement="right"></app-tooltip>
                  </div>
                  </a>
                </li> -->

        <li class="menu-list">
          <a
            class="menu-link"
            routerLink="orders"
            aria-label="Orders"
            routerLinkActive="active-link"
            ariaCurrentWhenActive="page"
            [appShortcutTooltip]="getShortcutInfo('ORDERS')">
            <app-ce-icon
              [name]="'cart'"
              [svg_class]="['cursor-pointer', 'main-menu']"></app-ce-icon>
          </a>
        </li>
        <!--TODO- <li class="menu-list">
                  <a
                    class="menu-link"
                    routerLink="/subscriptions"
                    aria-label="Subscriptions"
                    ariaCurrentWhenActive="page"
                    [ngClass]="{
                      'active-link': isActive(active_link, ['subscriptions'])
                    }">
                    <app-ce-icon
                      [name]="'recurring_invoice'"
                      [svg_class]="['cursor-pointer', 'main-menu']"></app-ce-icon>
                    <div class="tool d-none">
                      <app-tooltip
                        label="Subscriptions"
                        Type="default"
                        size="medium"
                        data-bs-placement="right"></app-tooltip>
                    </div>
                  </a>
                </li> -->
        <li class="menu-list">
          <a
            class="menu-link"
            routerLink="shipments"
            aria-label="Shipments"
            routerLinkActive="active-link"
            ariaCurrentWhenActive="page"
            [appShortcutTooltip]="getShortcutInfo('SHIPPING')">
            <app-ce-icon
              [name]="'truck'"
              [svg_class]="['cursor-pointer', 'main-menu']"></app-ce-icon>
          </a>
        </li>
      </ul>
      <div class="border-line"></div>
      <ul class="sideMenu">
        <li class="menu-list">
          <a
            class="menu-link"
            routerLink="payments"
            aria-label="Payments"
            routerLinkActive="active-link"
            ariaCurrentWhenActive="page"
            [appShortcutTooltip]="getShortcutInfo('PAYMENTS')">
            <app-ce-icon
              [name]="'bank'"
              [svg_class]="['cursor-pointer', 'main-menu']"></app-ce-icon>
          </a>
        </li>
        <li class="menu-list">
          <a
            class="menu-link"
            routerLinkActive="active-link"
            ariaCurrentWhenActive="page"
            tabindex="0"
            aria-haspopup="true"
            [attr.aria-expanded]="isSubmenuOpen"
            (focus)="onParentFocus($event)"
            (blur)="onParentBlur($event)"
            (keydown)="onParentMenuKeydown($event)">
            <app-ce-icon
              [name]="'invoice'"
              [svg_class]="['cursor-pointer', 'main-menu']"></app-ce-icon>
            <ul
              class="hover-menu custom-dropdown border-radius side-nav-list h3-bold primary-100"
              role="menu"
              aria-label="Promotions submenu">
              <li>
                @let couponsInfo = getShortcutInfo('COUPONS');
                <a
                  class="cursor-pointer"
                  routerLink="coupons"
                  role="menuitem"
                  tabindex="-1"
                  (keydown)="onSubmenuKeydown($event)"
                  [appShortcutTooltip]="getShortcutInfo('COUPONS')"
                  [appShortcutTooltipKeysOnly]="true"
                  (click)="onSubmenuClick($event)"
                  ><span
                    ><app-ce-icon
                      [name]="'coupon'"
                      [svg_class]="['cursor-pointer', 'primary-50']"></app-ce-icon
                  ></span>
                  <div class="menu-text">{{ couponsInfo.name }}</div>
                </a>
              </li>
              <li>
                @let promotionsInfo = getShortcutInfo('PROMOTIONS');
                <a
                  class="cursor-pointer"
                  routerLink="promotions"
                  role="menuitem"
                  tabindex="-1"
                  (keydown)="onSubmenuKeydown($event)"
                  [appShortcutTooltip]="getShortcutInfo('PROMOTIONS')"
                  [appShortcutTooltipKeysOnly]="true"
                  (click)="onSubmenuClick($event)"
                  ><span
                    ><app-ce-icon
                      [name]="'percentage'"
                      [svg_class]="['cursor-pointer', 'primary-50']"></app-ce-icon
                  ></span>
                  <div class="menu-text">{{ promotionsInfo.name }}</div>
                </a>
              </li>
            </ul>
          </a>
        </li>
        <li class="menu-list">
          <a
            class="menu-link"
            routerLink="analytics/live-events"
            aria-label="Live Events"
            routerLinkActive="active-link"
            ariaCurrentWhenActive="page"
            [appShortcutTooltip]="getShortcutInfo('LIVE_EVENTS')">
            <app-ce-icon
              [name]="'bar_graph'"
              [svg_class]="['cursor-pointer', 'main-menu']"></app-ce-icon>
          </a>
        </li>
        <!-- <li class="menu-list">
          <a class="menu-link" routerLinkActive="active-link" ariaCurrentWhenActive="page">
            <app-ce-icon
              [name]="'bar_graph'"
              [svg_class]="['cursor-pointer', 'main-menu']"></app-ce-icon>
            <ul class="hover-menu custom-dropdown border-radius side-nav-list h3-bold primary-100">
              <li>
                <a class="cursor-pointer" routerLink="analytics"
                  ><span
                    ><app-ce-icon
                      [name]="'bar_graph'"
                      [svg_class]="['cursor-pointer', 'primary-50']"></app-ce-icon></span
                  >Analytics</a
                >
              </li>
              <li>
                <a class="cursor-pointer" routerLink="analytics/live-events"
                  ><span
                    ><app-ce-icon
                      [name]="'subscription'"
                      [svg_class]="['cursor-pointer', 'primary-50']"></app-ce-icon></span
                  >Live Events</a
                >
              </li>
            </ul>
          </a>
        </li> -->
      </ul>
      <div class="border-line"></div>
      <ul class="sideMenu">
        <!-- Campaigns Module -->
        <!-- <li class="menu-list">
          <a
            class="menu-link"
            routerLink="campaigns"
            aria-label="Campaigns"
            routerLinkActive="active-link"
            ariaCurrentWhenActive="page"
            [matTooltip]="'Campaigns'"
            [matTooltipPosition]="'right'">
            <app-ce-icon
              [name]="'filter'"
              [svg_class]="['cursor-pointer', 'main-menu']"></app-ce-icon>
          </a>
        </li> -->
        <!-- Segments Module -->
        <!-- <li class="menu-list">
          <a
            class="menu-link"
            routerLink="segments"
            aria-label="Segments"
            routerLinkActive="active-link"
            ariaCurrentWhenActive="page"
            [matTooltip]="'Segments'"
            [matTooltipPosition]="'right'">
            <app-ce-icon
              [name]="'coupon'"
              [svg_class]="['cursor-pointer', 'main-menu']"></app-ce-icon>
          </a>
        </li> -->
        <!-- Loyalty Module -->
        <li class="menu-list">
          <a
            class="menu-link"
            routerLink="loyalty"
            aria-label="loyalty"
            routerLinkActive="active-link"
            ariaCurrentWhenActive="page"
            [appShortcutTooltip]="getShortcutInfo('LOYALTY')">
            <app-ce-icon
              [name]="'certificate'"
              [svg_class]="['cursor-pointer', 'main-menu']"></app-ce-icon>
          </a>
        </li>
        <!-- Conversations Module -->
        <!-- <li class="menu-list">
          <a class="menu-link" routerLinkActive="active-link" ariaCurrentWhenActive="page">
            <app-ce-icon
              [name]="'chat'"
              [svg_class]="['cursor-pointer', 'main-menu']"></app-ce-icon>
            <ul
              class="hover-menu last-menu custom-dropdown border-radius side-nav-list h3-bold primary-100">
              <li>
                <a class="cursor-pointer" routerLink="conversations"
                  ><span
                    ><app-ce-icon
                      [name]="'chat'"
                      [svg_class]="['cursor-pointer', 'primary-50']"></app-ce-icon></span
                  >Conversations</a
                >
              </li>
              <li>
                <a class="cursor-pointer" routerLink="tickets"
                  ><span
                    ><app-ce-icon
                      [name]="'note'"
                      [svg_class]="['cursor-pointer', 'primary-50']"></app-ce-icon></span
                  >Tickets</a
                >
              </li>
              <li>
                <a class="cursor-pointer" routerLink="faqs"
                  ><span
                    ><app-ce-icon
                      [name]="'help'"
                      [svg_class]="['cursor-pointer', 'primary-50']"></app-ce-icon></span
                  >FAQs</a
                >
              </li>
            </ul>
          </a>
        </li> -->
        <!-- Media Module -->
        <li class="menu-list">
          <a
            class="menu-link"
            routerLink="media"
            aria-label="media"
            routerLinkActive="active-link"
            ariaCurrentWhenActive="page"
            [appShortcutTooltip]="getShortcutInfo('MEDIA')">
            <app-ce-icon
              [name]="'camera'"
              [svg_class]="['cursor-pointer', 'main-menu']"></app-ce-icon>
          </a>
        </li>
      </ul>
    </div>
    <div class="bottom-nav">
      <ul class="sideMenu">
        <li class="menu-list">
          <a
            class="menu-link"
            routerLink="settings"
            aria-label="settings"
            routerLinkActive="active-link"
            ariaCurrentWhenActive="page"
            [appShortcutTooltip]="getShortcutInfo('SETTINGS')">
            <app-ce-icon
              [name]="'settings'"
              [svg_class]="['cursor-pointer', 'main-menu']"></app-ce-icon>
          </a>
        </li>
      </ul>
    </div>
  </nav>
}
@if (settings === menuSettings.OrganisationSetting) {
  <nav class="side-nav" role="navigation" aria-label="Organization navigation">
    <div class="logo">
      <img class="cursor-pointer" height="27" width="24" alt="" ngSrc="/assets/logo.svg" priority />
    </div>
    <div class="side-nav-top">
      <ul class="sideMenu">
        <li class="menu-list">
          <a
            class="menu-link"
            routerLink="/organization"
            aria-label="Organisation"
            routerLinkActive="active-link"
            ariaCurrentWhenActive="page"
            [appShortcutTooltip]="getShortcutInfo('ORGANIZATION')">
            <app-ce-icon
              [name]="'settings'"
              [svg_class]="['cursor-pointer', 'main-menu']"></app-ce-icon>
          </a>
        </li>
      </ul>
    </div>
  </nav>
}
